// Ampel / status helpers shared across the board
export const TEXT_OPTIONS = [
  { value: "kein_text", label: "KEIN TEXT VORHANDEN", cls: "bg-red-500 text-white border-red-600" },
  { value: "text_vorhanden", label: "TEXT VORHANDEN", cls: "bg-yellow-400 text-slate-900 border-yellow-500" },
];

export const PHOTO_OPTIONS = [
  { value: "keine_fotos", label: "KEINE FOTOS", cls: "bg-slate-200 text-slate-600 border-slate-300" },
  { value: "fotos_vorhanden", label: "FOTOS VORHANDEN", cls: "bg-sky-400 text-white border-sky-500" },
  { value: "fotos_online", label: "FOTOS ONLINE", cls: "bg-blue-600 text-white border-blue-700" },
];

export const RELEASE_OPTIONS = [
  { value: "offen", label: "FREIGABE OFFEN", cls: "bg-slate-200 text-slate-600 border-slate-300" },
  { value: "freigabe_erteilt", label: "FREIGABE ERTEILT", cls: "bg-emerald-500 text-white border-emerald-600" },
];

export const CUSTOMER_TYPES = [
  { value: "partner", label: "Partner / Sponsor (Freianzeige)", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "bezahlkunde", label: "Anzeigenkunde", cls: "bg-blue-50 text-blue-700 border-blue-200" },
];

export const CUSTOMER_STATUS = [
  { value: "offen", label: "Offen" },
  { value: "angefragt", label: "Angefragt" },
  { value: "unterlagen_da", label: "Unterlagen da" },
  { value: "abgeschlossen", label: "Abgeschlossen" },
];

export const PERSON_FUNCTIONS = [
  { value: "chefredakteur", label: "Chefredakteur", cls: "bg-[#0B132B] text-white border-[#0B132B]" },
  { value: "redakteur", label: "Redakteur", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  { value: "vorstand", label: "Vorstand", cls: "bg-red-50 text-red-700 border-red-200" },
  { value: "mitarbeitende", label: "Mitarbeitende", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  { value: "autor", label: "Autor", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "fotograf", label: "Fotograf", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "layout", label: "Layout", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  { value: "sonstige", label: "Sonstige", cls: "bg-stone-50 text-stone-600 border-stone-200" },
];

export const find = (opts, v) => opts.find((o) => o.value === v) || opts[0];
